import { req } from '@/providers/axios.provider'

import type { UserT } from './auth.api'

export type BookStatusT = 'in_progress' | 'shipped' | 'submitted_to_print'

// ------------------------------------------------------------------

export const API_UPDATE_UserProfile = async (data: {
  name?: string
  image?: string
  country?: string | null
  ip?: string | null
}): Promise<UserT> => {
  const res = await req.patch<UserT>(`/api/users/me/profile`, data)
  return res
}

// ------------------------------------------------------------------

export const API_UPDATE_UserFrozenStatus = async (): Promise<UserT> => {
  const res = await req.patch<UserT>(`/api/users/me/frozen-status`)
  return res
}

// ------------------------------------------------------------------

export const API_UPDATE_UserIsOnboarded = async (): Promise<UserT> => {
  const res = await req.patch<UserT>(`/api/users/me/onboarded-status`)
  return res
}

// ------------------------------------------------------------------

export const API_UPDATE_UserNpsFirstAnswer = async (hasSeen: boolean): Promise<UserT> => {
  const res = await req.patch<UserT>(`/api/users/me/nps-first-answer`, {
    hasSeen,
  })
  return res
}

// ------------------------------------------------------------------

export const API_UPDATE_UserRenewalRewardClaim = async (): Promise<UserT> => {
  const res = await req.patch<UserT>(`/api/users/me/renewal-reward-claim`)
  return res
}

// ------------------------------------------------------------------

export const API_UPDATE_UserPaymentDeclined = async (): Promise<UserT> => {
  const res = await req.patch<UserT>(`/api/users/me/payment-declined`)
  return res
}

// ------------------------------------------------------------------
